/** Strip or shorten protocol tokens in user-visible connectivity logs. */
export function sanitizeUserLog(text: string): string {
  return text
    .replace(/\bTURN\b/g, 't')
    .replace(/\bturn\b/g, 't')
    .replace(/\bSTUN\b/g, 's')
    .replace(/\bstun\b/g, 's')
    .replace(/\bsrflx\b/g, 'sf')
    .replace(/\brelay\b/g, 't')
    .replace(/\bWebRTC\b/gi, 'connectivity')
    .replace(/\bICE\b/g, 'i')
    .replace(/\bSDP\b/g, 'session');
}

export function formatGatheringSummary(counts: {
  host?: number;
  srflx?: number;
  relay?: number;
}): string {
  const parts: string[] = [];
  if ((counts.host ?? 0) > 0) parts.push(`h:${counts.host}`);
  if ((counts.srflx ?? 0) > 0) parts.push(`sf:${counts.srflx}`);
  if ((counts.relay ?? 0) > 0) parts.push(`t:${counts.relay}`);
  return parts.length ? `Gathering done (${parts.join(' ')})` : 'Gathering done';
}

/** User-facing label for RTCPeerConnection.iceConnectionState (or similar). */
export function userIceConnectionLabel(state: string): string | null {
  switch (state) {
    case 'checking':
      return 'Checking connectivity…';
    case 'connected':
    case 'completed':
      return 'Attempting connectivity';
    case 'failed':
      return 'Connectivity failed';
    case 'disconnected':
      return 'Connectivity interrupted';
    default:
      return null;
  }
}

export function userDialPhaseLabel(phase: 'stun' | 'turn'): string {
  return phase === 'turn' ? 'Trying alternate route…' : 'Connecting…';
}
